var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngularIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M23.933 2L3 9.285 6.308 36.408 23.955 46 41.693 36.278 45 9.156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b71c1c",
    d: "M42.818 10.527L24 4.135 24 43.695 39.832 35.017z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M23.941 4.115L5.181 10.644 8.168 35.143 23.951 43.721 24 43.695 24 4.135z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M24 5.996L24 15.504 32.578 34 36.987 34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M11.013 34L15.422 34 24 15.504 24 5.996z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M24 24H30V28H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M18 24H24V28H18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularIcon);
export default __webpack_public_path__ + "static/media/angular-icon.f9ef2acacb9c7dcc60c405977c26f5fe.svg";
export { ForwardRef as ReactComponent };